module.exports = __webpack_public_path__ + "img/0S6A9913.4b86b7dc.jpg";